// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__27QVC","rootSuccess":"CompleteLink_rootSuccess__M0Ogw","rootFailure":"CompleteLink_rootFailure__cpZmI","isDisabled":"CompleteLink_isDisabled__-W5I8"};